// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-signup2 {
    max-width: 100%;
    height: auto;
    background: #FFF;
    display: flex;
    flex-direction: row;
    margin-top: 0;
}

.base-signup2 .left-section {
    width: 100%;
    height: auto;
    position: relative;
}

.base-signup2 .back {
    width: 61px;
    height: 61px;
    position: absolute;
    left: 49px;
    top: 39px;
}

.base-signup2 .box {
    display: flex; /* Changed to flex for responsive layout */
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    padding: 88px; /* Adjust as needed */
    box-sizing: border-box;
    position: static; /* Ensure it's within normal flow */
}

.base-signup2 .title {
    display: flex;
    width: 100%;
    min-height: 54px; /* Changed from fixed height to min-height */
    flex-direction: column;
    justify-content: center;
    color: var(--greyscale-greyscale-100, #111);
    font-family: Georgia;
    font-size: 46px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.1; /* Keep the adjusted line height */
    margin-bottom: 10px; /* Add margin to create space between title and desc */
    word-wrap: break-word; /* Allow long words to break and wrap */
    overflow-wrap: break-word; /* Ensure words break and wrap as needed */
}

.base-signup2 .desc {
    display: flex;
    width: 100%;
    min-height: 32px; /* Changed from fixed height to min-height */
    flex-direction: column;
    justify-content: center;
    color: var(--greyscale-greyscale-70, #6D6D6D);
    font-size: 25px;
    font-style: normal;
    font-weight: 300;
    line-height: 1.2; /* Adjusted for better readability */
    word-wrap: break-word; /* Allow long words to break and wrap */
    overflow-wrap: break-word; /* Ensure words break and wrap as needed */
}

.base-signup2 .un {
    width: 100%;
    height: 56px;
    flex-shrink: 0;
    background: var(--greyscale-greyscale-5, #F8F8F8);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-top: 20px;
    gap: 30px;
    position: relative; /* Add position relative for absolute positioning of the line */
}

.base-signup2 .un::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #cecece;
}

.base-signup2 .input {
    flex-grow: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 18px;
    font-weight: 400;
    color: #111;
    padding-left: 15px;
    width: 100%;
}

.base-signup2 .input-select {
    flex-grow: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 18px;
    font-weight: 400;
    color: #111;
    width: 100%;
}

.base-signup2 .required-field::before {
    content: '*';
    color: red;
    position: absolute;
    left: 10px; 
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
}

.base-signup2 .rect {
    width: 100%;
    height: 1px;
    flex-shrink: 0;
    background: var(--greyscale-greyscale-20, #CECECE);
}

.base-signup2 .button-container {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 30px;
}

.base-signup2 .button {
    display: inline-flex;
    padding: 14px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    background-color: #458BEA;
    color: #FFF;
}

.base-signup2 .disclaimer {
    font-size: 9px;
    color: gray;
    margin-top: 20px;
    text-align: left;
}

/* Media query for responsiveness */
@media (max-width: 1220px) {
    .base-signup2 {
        flex-direction: column;
    }

    .base-signup2 .left-section {
        width: 100%;
        height: auto;
        margin: 0;
    }

    .base-signup2 .box {
        padding: 20px;
        position: static;
    }
}


.base-signup2 .input-select-container {
    position: relative;
    z-index: 2; 
}
`, "",{"version":3,"sources":["webpack://./src/components/Setup2/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa,EAAE,0CAA0C;IACzD,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,aAAa,EAAE,qBAAqB;IACpC,sBAAsB;IACtB,gBAAgB,EAAE,mCAAmC;AACzD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB,EAAE,4CAA4C;IAC9D,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;IAC3C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB,EAAE,kCAAkC;IACpD,mBAAmB,EAAE,sDAAsD;IAC3E,qBAAqB,EAAE,uCAAuC;IAC9D,yBAAyB,EAAE,0CAA0C;AACzE;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB,EAAE,4CAA4C;IAC9D,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB,EAAE,oCAAoC;IACtD,qBAAqB,EAAE,uCAAuC;IAC9D,yBAAyB,EAAE,0CAA0C;AACzE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,kBAAkB,EAAE,+DAA+D;AACvF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".base-signup2 {\n    max-width: 100%;\n    height: auto;\n    background: #FFF;\n    display: flex;\n    flex-direction: row;\n    margin-top: 0;\n}\n\n.base-signup2 .left-section {\n    width: 100%;\n    height: auto;\n    position: relative;\n}\n\n.base-signup2 .back {\n    width: 61px;\n    height: 61px;\n    position: absolute;\n    left: 49px;\n    top: 39px;\n}\n\n.base-signup2 .box {\n    display: flex; /* Changed to flex for responsive layout */\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n    padding: 88px; /* Adjust as needed */\n    box-sizing: border-box;\n    position: static; /* Ensure it's within normal flow */\n}\n\n.base-signup2 .title {\n    display: flex;\n    width: 100%;\n    min-height: 54px; /* Changed from fixed height to min-height */\n    flex-direction: column;\n    justify-content: center;\n    color: var(--greyscale-greyscale-100, #111);\n    font-family: Georgia;\n    font-size: 46px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 1.1; /* Keep the adjusted line height */\n    margin-bottom: 10px; /* Add margin to create space between title and desc */\n    word-wrap: break-word; /* Allow long words to break and wrap */\n    overflow-wrap: break-word; /* Ensure words break and wrap as needed */\n}\n\n.base-signup2 .desc {\n    display: flex;\n    width: 100%;\n    min-height: 32px; /* Changed from fixed height to min-height */\n    flex-direction: column;\n    justify-content: center;\n    color: var(--greyscale-greyscale-70, #6D6D6D);\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 1.2; /* Adjusted for better readability */\n    word-wrap: break-word; /* Allow long words to break and wrap */\n    overflow-wrap: break-word; /* Ensure words break and wrap as needed */\n}\n\n.base-signup2 .un {\n    width: 100%;\n    height: 56px;\n    flex-shrink: 0;\n    background: var(--greyscale-greyscale-5, #F8F8F8);\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    margin-top: 20px;\n    gap: 30px;\n    position: relative; /* Add position relative for absolute positioning of the line */\n}\n\n.base-signup2 .un::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #cecece;\n}\n\n.base-signup2 .input {\n    flex-grow: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 18px;\n    font-weight: 400;\n    color: #111;\n    padding-left: 15px;\n    width: 100%;\n}\n\n.base-signup2 .input-select {\n    flex-grow: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 18px;\n    font-weight: 400;\n    color: #111;\n    width: 100%;\n}\n\n.base-signup2 .required-field::before {\n    content: '*';\n    color: red;\n    position: absolute;\n    left: 10px; \n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 1;\n}\n\n.base-signup2 .rect {\n    width: 100%;\n    height: 1px;\n    flex-shrink: 0;\n    background: var(--greyscale-greyscale-20, #CECECE);\n}\n\n.base-signup2 .button-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin-top: 30px;\n}\n\n.base-signup2 .button {\n    display: inline-flex;\n    padding: 14px 24px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    background-color: #458BEA;\n    color: #FFF;\n}\n\n.base-signup2 .disclaimer {\n    font-size: 9px;\n    color: gray;\n    margin-top: 20px;\n    text-align: left;\n}\n\n/* Media query for responsiveness */\n@media (max-width: 1220px) {\n    .base-signup2 {\n        flex-direction: column;\n    }\n\n    .base-signup2 .left-section {\n        width: 100%;\n        height: auto;\n        margin: 0;\n    }\n\n    .base-signup2 .box {\n        padding: 20px;\n        position: static;\n    }\n}\n\n\n.base-signup2 .input-select-container {\n    position: relative;\n    z-index: 2; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
